import React, { createContext, useState } from "react";

interface IContextState {
  children: React.ReactNode;
}

interface IContextStateData {
  step?: number;
  bankName?: string;
  bankCode?: string;
  bankNameKatakana?: string;
  selectBankValue?: string;
  branchName?: string;
  branchCode?: string;
  branchNameKatakana?: string;
  selectBranchValue?: string;
}

export const TkBankSelectionContext = createContext<{
  state: IContextStateData;
  setState: (data: IContextStateData) => void;
}>({
  state: {},
  setState: (data: IContextStateData) => {},
});

export const TkBankSelectionProvider: React.FC<IContextState> = (props) => {
  const { children } = props;

  const [state, setState] = useState<IContextStateData>({});

  return (
    <TkBankSelectionContext.Provider value={{ state, setState }}>
      {children}
    </TkBankSelectionContext.Provider>
  );
};
